import styled, {css} from 'styled-components'
import media from '../../../utils/media'

export const SectionHero = styled.section`
  position: relative;

  padding-top: 16px;
  //padding-bottom: 0;
  ${media.md`
    //padding-top: 81px;
    //padding-bottom: 1rem;
  `}
  padding-bottom: 64px;

  //min-height: 500px;

  ${props => (props.pb != null) && css`
    padding-bottom: ${props.pb};
  `}
`

export const Container = styled.div`
  position: relative;
  max-width: 740px;
  padding: 24px 20px 0;
  margin: 0 auto;
  ${media.md`
    padding-top: 40px;
  `}
  ${media.xl`
    max-width: 1200px;
    padding-left: 10px;
    padding-right: 10px;
  `}
`

export const InfoText = styled.div`
  font-size: 14px;
  line-height: 1.6;
  text-align: left;
  color: #767676;
`

export const InfoTextH1 = styled.h1`
  margin: 0;
  padding: 0;
  color: #484848;
  margin-bottom: 16px;
  font-size: 16px;
  ${media.md`
    font-size: 24px;
  `}
`

export const InfoTextP = styled.p`
  margin: 0;
  padding: 0;
  & + & {
    margin-top: 12px;
  }
`



// WEBPACK FOOTER //
// ./src/screens/Legal/FindThreeMobilePrivacyPolicy/styles.js